module.exports = __webpack_public_path__ + "img/front_eaxmple.22bf620f.png";